"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useMessages;
var _react = require("react");
var _intlProvider = require("./intl-provider.js");
/**
 * React hook that returns all messages from the provider context
 * @returns {object} The messages object from the context
 */
function useMessages() {
  var _useContext = (0, _react.useContext)(_intlProvider.PolyfillReactIntl),
    messages = _useContext.messages;
  return messages;
}